export class CourierConfig {
  static isEnabled = false
}
